import React from 'react'
import { Icon } from './CallChat.elements'

type Props = {
  className?: string
}

export const CallChatIcon = ({ className }: Props) => (
  <Icon
    viewBox="0 0 80 80"
    aria-hidden
    focusable={false}
    role="img"
    className={className}
    fill="none"
  >
    <path d="M57.49 56.141v6.924a4.607 4.607 0 01-1.5 3.42 4.628 4.628 0 01-3.542 1.196 45.822 45.822 0 01-19.957-7.085 45.048 45.048 0 01-13.875-13.848 45.616 45.616 0 01-7.1-20.01 4.606 4.606 0 011.191-3.527 4.625 4.625 0 013.412-1.504h6.937a4.63 4.63 0 013.061 1.116 4.614 4.614 0 011.564 2.854 29.584 29.584 0 001.619 6.485 4.607 4.607 0 01-1.04 4.87l-2.938 2.93A36.963 36.963 0 0039.197 53.81l2.937-2.93a4.627 4.627 0 014.88-1.04 29.742 29.742 0 006.498 1.616 4.627 4.627 0 012.882 1.587 4.61 4.61 0 011.095 3.098z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M53.724 35.967l-10.621 5.929v-5.93H40.61a3.41 3.41 0 01-3.409-3.409V18.03a3.41 3.41 0 013.41-3.409h23.865a3.41 3.41 0 013.41 3.41v14.526a3.41 3.41 0 01-3.41 3.41H53.724z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
    <rect x="44.923" y="17.428" width="16.044" height="16.044" rx="8.022" fill="#128EE8" />
    <path d="M49.602 25.028l2.435 2.434 4.294-4.294" stroke="#fff" strokeWidth="1.604" />
  </Icon>
)
